import authRoutes from './auth';
import modelInferenceRoutes from './modelInference';
import modelTrainingRoutes from './modelTraining';
import datasetManagementRoutes from './datasetManagement';
import cloudStudioRoutes from './cloudStudio';
import usageRecordRoutes from './usageRecord';
import billingManagementRoutes from './billingManagement';
import systemRoutes from './system';
import commonRoutes from './common';
import { homeRoute, overviewRoute } from './home';

/** 按一级模块汇总路由；保留菜单顺序，通用兜底路由放在末尾。 */
export default [
  ...authRoutes,
  overviewRoute,
  modelInferenceRoutes,
  modelTrainingRoutes,
  datasetManagementRoutes,
  cloudStudioRoutes,
  usageRecordRoutes,
  billingManagementRoutes,
  systemRoutes,
  homeRoute,
  ...commonRoutes,
];
